import { Children, PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

import { appLocales } from 'i18n';
import { userSelector, companySelector } from 'containers/App/selectors';
import { DEFAULT_LOCALE } from 'containers/App/constants/language';
import { localeSelector } from './selectors';

export const normalizeLocale = (locale) => {
  const language = (locale || '').split('-')[0].toLowerCase();
  return appLocales.includes(language) ? language : DEFAULT_LOCALE;
};

export class LanguageProviderComponent extends PureComponent {
  render() {
    const { locale, messages, children, user, company } = this.props;

    // user locale override > company selected locale > browser locale (if null or simple user) > default to 'en'
    const activeLocale = normalizeLocale(
      user?.locale_override ||
        company?.selected_locale ||
        (!user || user.is_simple
          ? typeof navigator !== 'undefined' && navigator.language
          : locale)
    );

    const localeMessages = messages[activeLocale] || {};
    moment.locale(activeLocale);

    return (
      <IntlProvider
        locale={activeLocale}
        messages={localeMessages}
        textComponent={Fragment}
      >
        {Children.only(children)}
      </IntlProvider>
    );
  }
}

LanguageProviderComponent.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
  user: PropTypes.object,
  company: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  locale: localeSelector,
  user: userSelector,
  company: companySelector,
});

export const LanguageProvider = connect(
  mapStateToProps,
  null
)(LanguageProviderComponent);
